import type { ProceduralRoomContent } from './types';

export function safeRoomContent(floor: number): ProceduralRoomContent {
  return {
    name: 'Phòng An Toàn',
    description: 'Vùng thánh địa. Nghỉ ngơi hồi đầy ma lực.',
    safetyTag: 'Khu vực an toàn',
    bgImageKey: 'bg_safe_room',
    isCleared: true,
    isRequiredInteraction: false,
    options: [
      {
        id: `rest_safe_${floor}`,
        action: 'REST_SAFE',
        actionText: '⛺ Nghỉ ngơi (Hồi 100% MP)',
        consequence: { healMpPercent: 100, message: '⛺ Hồi phục 100% Ma Lực.' },
      },
    ],
  };
}

export function bossRoomContent(floor: number): ProceduralRoomContent {
  return {
    name: `Sào Huyệt Boss Tầng ${floor}`,
    description: 'Không khí đặc quánh. Thủ vệ tầng đang chờ.',
    safetyTag: 'Phòng Boss',
    bgImageKey: 'bg_boss_room',
    isCleared: false,
    isRequiredInteraction: true,
    options: [
      {
        id: `boss_${floor}`,
        action: 'COMBAT_BOSS',
        actionText: '💀 Khiêu chiến Boss',
        consequence: {
          triggerCombat: true,
          enemyId: 'demon_commander',
          bossName: 'Demon Commander',
          message: '💀 Boss xuất hiện. Bạn ra tay trước.',
        },
      },
    ],
  };
}

export function teleporterRoomContent(floor: number): ProceduralRoomContent {
  return {
    name: 'Ma Trận Dịch Chuyển',
    description: 'Cổng dẫn xuống tầng sâu hơn; đánh boss là tùy chọn.',
    safetyTag: 'Lối xuống tầng',
    bgImageKey: 'bg_teleporter_room',
    isCleared: true,
    isRequiredInteraction: false,
    options: [
      {
        id: `tp_${floor}`,
        action: 'TELEPORT',
        actionText: `🌀 Xuống tầng ${floor + 1}`,
        consequence: {
          nextFloor: floor + 1,
          message: `🌀 Tiến sang tầng ${floor + 1}.`,
        },
      },
    ],
  };
}
